export default "__VITE_ASSET__DoUkYmTq__"